/** @format */

import React, { PureComponent } from 'react';
import I18n from '../../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import { GetContainViewProps } from '../../../modules/block/BlockContainHelper';
import { SleepTimeElement } from '../SleepTimeElement';

class Finish extends PureComponent<GetContainViewProps> {
    render(): React.ReactNode {
        const { element } = this.props;
        const endName = 'prov:f.end request';

        return (
            <Card>
                <CardHeader>
                    <Typography variant="subtitle1">
                        <I18n trans={endName} />
                    </Typography>
                </CardHeader>
                <CardBody xs={12}>
                    <SleepTimeElement seconds={element.sleepSeconds} />
                </CardBody>
            </Card>
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(Finish);
